import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessageBubble = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.8803 13.5301C20.2703 17.2701 17.4803 20.1301 13.7703 20.8301C11.7303 21.2201 9.80026 20.9101 8.13026 20.1301C7.85026 19.9901 7.41024 19.9401 7.11024 20.0001C6.49024 20.1501 5.43023 20.4101 4.54023 20.6101C3.68023 20.8201 3.15025 20.2901 3.37025 19.4401L3.98024 16.8801C4.05024 16.5801 3.98023 16.1301 3.85023 15.8501C3.09023 14.2601 2.79023 12.4101 3.10023 10.4701C3.70023 6.75007 6.72027 3.73006 10.4503 3.11006C16.6103 2.12006 21.8602 7.36006 20.8502 13.5201L20.8803 13.5301Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6501 12H8.8501",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1501 12H13.3501",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMessageBubble;
